export default class BeneficioPlano {
    constructor() {
        this.id = null;
        this.nome = '';
        this.selecionado = true;
    }
}